/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Mode_Use_CaseInputs */

const en_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`use case`)
};

const zh_hans1_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用场景`)
};

const pt_br2_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caso de uso`)
};

const es_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caso de uso`)
};

const fr_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cas d’usage`)
};

const de_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwendungsfall`)
};

const ru_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`задача`)
};

const it_search_mode_use_case = /** @type {(inputs: Search_Mode_Use_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caso d'uso`)
};

/**
* | output |
* | --- |
* | "use case" |
*
* @param {Search_Mode_Use_CaseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_mode_use_case = /** @type {((inputs?: Search_Mode_Use_CaseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Mode_Use_CaseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_mode_use_case(inputs)
	if (locale === "pt-BR") return pt_br2_search_mode_use_case(inputs)
	if (locale === "es") return es_search_mode_use_case(inputs)
	if (locale === "fr") return fr_search_mode_use_case(inputs)
	if (locale === "de") return de_search_mode_use_case(inputs)
	if (locale === "ru") return ru_search_mode_use_case(inputs)
	if (locale === "it") return it_search_mode_use_case(inputs)
	return en_search_mode_use_case(inputs)
});